<template>
    <div class="container mb-4 privacy-opt-out">
        <form class="row form-container" v-show="!output">
            <div class="col-12 col-md-6 col-lg-4 mb-3">
                <InputField
                    :customErrorMessage="$t('form.fields.emailAddress.errorMessage')"
                    :validationRules="{
                        required: true,
                        loqateEmail: true,
                        max: 100,
                    }"
                    name="emailAddress"
                    type="email"
                    vuexKey="internal.privacyForm"
                    :label="$t('form.fields.emailAddress.label')"
                />
            </div>

            <div class="col-12 checkbox-container">
                <Checkbox
                    name="communicationRevoke"
                    :label="$t('optOut.communicationRevoke')"
                    vuexKey="internal.privacyForm"
                />
            </div>

            <div class="col-12 checkbox-container">
                <Checkbox name="analyzeRevoke" :label="$t('optOut.analyzeRevoke')" vuexKey="internal.privacyForm" />
            </div>

            <div class="col-12 checkbox-container">
                <Checkbox name="shareRevoke" :label="$t('optOut.shareRevoke')" vuexKey="internal.privacyForm" />
            </div>

            <div class="col-12 col-md-6 col-lg-4 mt-3">
                <button :disabled="busy" class="button secondary submit-button" @click="submit">
                    {{ $t('optOut.buttonLabel') }}

                    <div class="spinner-border spinner-border-sm text-light ml-1" role="status" v-show="busy">
                        <span class="sr-only">{{ $t('form.general.loading') }}...</span>
                    </div>
                </button>
            </div>
        </form>

        <div class="row" v-show="output">
            <div class="col-12">
                {{ output }}
            </div>
        </div>
    </div>
</template>

<script>
import { useForm } from 'vee-validate'
import { useStore } from 'vuex'
import { url } from '@js/utilities/url.js'

export default {
    data() {
        return {
            output: null,
            busy: false,
        }
    },
    setup() {
        const store = useStore()
        const { validate } = useForm()

        return {
            store,
            validate,
        }
    },
    methods: {
        submit: async function (e) {
            e.preventDefault()
            this.busy = true

            const validation = await this.validate()

            if (!validation.valid) {
                this.busy = false
                return
            }

            let result

            try {
                result = await axios.post(url('privacy/check-options'), {
                    email: this.store.state.apply.internal.privacyForm.emailAddress.value,
                    communication_revoke: this.store.state.apply.internal.privacyForm.communicationRevoke.value,
                    analyze_revoke: this.store.state.apply.internal.privacyForm.analyzeRevoke.value,
                    share_revoke: this.store.state.apply.internal.privacyForm.shareRevoke.value,
                })

                this.output = result.data.msg
            } catch (error) {
                console.error(error)
                this.output = this.$t('errors.pages.clientError.description')
            }

            this.busy = false
        },
    },
}
</script>

<style lang="scss">
@import '~scss/mixins/rem';

.privacy-opt-out {
    .checkbox-container {
        label {
            > span {
                font-size: rem(14px);
                font-weight: bold;
            }
        }
    }

    .block {
        .checkbox-label {
            color: var(--text-dark);
            font-weight: bold;
        }
    }

    .checkbox-label {
        color: var(--text-default);
        font-size: rem(14px);
        line-height: rem(20px);
        text-align: left;

        a {
            color: var(--text-dark);
            font-weight: bold;
        }
    }
}
</style>
